import { StandardEvents } from '@shopify/events';

class RemaxPartInformation extends HTMLElement {
  connectedCallback() {
    if (this.section) return;
    this.section = this.closest('.shopify-section, dialog');
    this.updateVersion = 0;
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
    this.section = null;
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const version = ++this.updateVersion;
    event.promise.then(({ detail }) => {
      if (!detail?.html || version !== this.updateVersion) return;
      if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
      const replacement = detail.html.querySelector(`remax-part-information[data-block-id="${CSS.escape(this.dataset.blockId)}"]`);
      if (!replacement) return;
      this.replaceChildren(...Array.from(replacement.childNodes, (node) => node.cloneNode(true)));
      this.dataset.productId = replacement.dataset.productId;
    }).catch(() => {});
  };
}

if (!customElements.get('remax-part-information')) customElements.define('remax-part-information', RemaxPartInformation);
